import { createContext } from 'react';
import { Respondent } from '../Records';

interface RespondentContextProps {
  respondent: Respondent;
  setRespondent?: (respondent: Respondent) => void;
}

export default createContext<RespondentContextProps>({
  respondent: new Respondent({}),
  setRespondent: undefined,
});
